import '.././teacherTests.css';
import React, {useContext} from 'react';
import {BrandContext} from "../../../common/BrandContext";
import PrePostTestTabs from "./PrePostTestTabs";
import TestGroupTabs from "./TestGroupTabs";

const Diagnostics = () => {

    const brandConfig = useContext(BrandContext),
        // testName = brandConfig.testName.toLowerCase();
        selfCreateDiagnostics = brandConfig.selfCreateDiagnostics,
        diagnosticNameLower = brandConfig.diagnosticName.toLowerCase();

    if(!selfCreateDiagnostics && !brandConfig.testGroupCodes) {
        return (
            <div className={'ch-warning-text'}>No {brandConfig.diagnosticsName} found</div>
        )
    }

    return (
        <>
            {!selfCreateDiagnostics && brandConfig.testGroupCodes && <PrePostTestTabs diagnosticNameLower={diagnosticNameLower}/>}
            {selfCreateDiagnostics && <TestGroupTabs diagnosticNameLower={diagnosticNameLower} testName={brandConfig.testName}/>}
        </>
    )

}
export default Diagnostics;
